import { InjectionToken } from '@angular/core';
import { environment } from '@environments/environment';

export const ASSETS_URL = new InjectionToken('assets url', {
  providedIn: 'root',
  factory: () => environment.urls.assets,
});
